export default __webpack_public_path__ + "static/media/resultsLogo.a13337f4.webp";